import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AsinsTable from "./_asins_table";
import FeatherIcon from "feather-icons-react";
import ComparsionDrawer from "../comparison/comparison_drawer";
import {
  checkIfInputIsAsin,
  downloadAsinListExcel,
  requestHandler,
  splitArrayIntoChunks,
  getUserFromDb,
  getMarketOptions,
} from "../../../../shared/utils/helpers";
import axios from "axios";
import translate from "../../../../shared/utils/translations";
import { InboxOutlined } from "@ant-design/icons";
import { Modal, Input, Upload, Button } from "antd";
import { Helmet } from "react-helmet";
const ExcelJS = require("exceljs");

const SavedAsins = ({ setPage }) => {
  useEffect(() => {
    setPage("dashboard-client");
    localStorage.setItem("dashboard-type", "dashboard-client");
  });

  const [tab, setTab] = useState("All");
  const [isComparisonDrawer, setComparisonDrawer] = useState(false);
  const [asinLists, setAsinLists] = useState([]);
  const [bufferAsinLists, setBufferAsinLists] = useState([]);
  const [query, setQuery] = useState("");
  const [asinListInfo, setAsinListInfo] = useState({});
  const [selectedAsinLists, setSelectedAsinLists] = useState([]);
  const [selectedAsinList, setSelectedAsinList] = useState({});
  const [selectedAsinListData, setSelectedAsinListData] = useState([]);
  const [isDownloadActive, setDownloadActive] = useState(false);
  const [modalUploadOpen, setModalUploadOpen] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [mapping, setMapping] = useState(null);
  const [listType, setListType] = useState();
  const [user, setUser] = useState({});
  useEffect(() => {
    getUserFromDb().then((res) => {
      console.log(res.data, res);
      setUser(res);
    });
  }, []);

  const [columnMappings, setColumnMappings] = useState({
    price: "",
    upc: "",
    currency: "USD",
    target_domain: "amazon.com",
  });
  const saveUpcList = async () => {
    await requestHandler("post", "/wholesale", {
      data: previewData,
      currency: columnMappings.currency,
      target_domain: columnMappings.target_domain,
      list_type: listType,
    });
  };
  const handleImport = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(data);

      const worksheet = workbook.getWorksheet(1);

      // Extract headers
      const headers = [];
      worksheet.getRow(1).eachCell((cell) => {
        headers.push(cell.text);
      });

      // Show headers to the user for mapping
      console.log("Headers:", headers);

      // Example: Dynamically create UI dropdowns for users to map the columns
      // Assuming setMapping is a state setter for the user's column mapping
      setMapping({ headers, worksheet });
    };

    reader.readAsArrayBuffer(file);
  };
  const handleMappingConfirm = () => {
    if (!columnMappings.price || !columnMappings?.[listType]) {
      alert("Please map all required columns!");
      return;
    }

    const { worksheet } = mapping;

    const priceRegex = /^\d+(\.\d{1,2})?$/; // Float with up to 2 decimal places
    const upcRegex = /^\d+$/; // Integer

    let data = [];
    let errors = [];

    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) {
        const upcValue =
          row.values[mapping.headers.indexOf(columnMappings?.[listType]) + 1];
        const priceValue =
          row.values[mapping.headers.indexOf(columnMappings.price) + 1];

        const isValidUPC = upcRegex.test(upcValue);
        const isValidPrice = priceRegex.test(priceValue);

        if (isValidUPC && isValidPrice) {
          data.push({
            [listType]: upcValue,
            price: parseFloat(priceValue), // Ensure price is a number
          });
        } else {
          errors.push({
            row: rowNumber,
            [listType]: upcValue,
            price: priceValue,
            error: !isValidUPC
              ? `Invalid ${listType}`
              : !isValidPrice
              ? "Invalid Price"
              : "Invalid Data",
          });
        }
      }
    });

    if (errors.length > 0) {
      console.error("Errors Found:", errors);
      setErrorData(errors);
      // alert("Some rows contain invalid data. Check the console for details.");
    }

    setPreviewData(data); // Set valid data for table preview
  };
  return (
    <>
      <Helmet>
        <title>{translate("Asin 360°")}</title>
      </Helmet>

      <Modal
        title={translate("Upload ASIN")}
        centered
        visible={modalUploadOpen}
        onOk={() => setModalUploadOpen(false)}
        onCancel={() => setModalUploadOpen(false)}
        footer={false}
      >
        <div className="card__file">
          <div className="drop_box__file">
            <h4>{translate("Select File Here.")}</h4>
            <p>{translate("Files Supported: .XLSX")}</p>
            <div className="upload__div">
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleImport}
              />
              <button className="btn__file">{translate("Choose File")}</button>
            </div>
          </div>
        </div>

        {mapping && (
          <div>
            <h4>Map Columns</h4>
            {/* select list type */}
            <div>
              <label>Select List Type:</label>
              <select
                onChange={(e) => setListType(e.target.value)}
                value={listType}
              >
                <option value="">Select List Type</option>
                <option value="upc">UPC</option>
                <option value="ean">EAN</option>
                <option value="asin">ASIN</option>
              </select>
            </div>

            {listType && (
              <div>
                <label>Select {listType} Column:</label>
                <select
                  onChange={(e) =>
                    setColumnMappings((prev) => ({
                      ...prev,
                      [listType]: e.target.value,
                    }))
                  }
                >
                  <option value="">Select Column</option>
                  {mapping.headers.map((header, index) => (
                    <option key={index} value={header}>
                      {header}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div>
              <label>Select Price Column:</label>
              <select
                onChange={(e) =>
                  setColumnMappings((prev) => ({
                    ...prev,
                    price: e.target.value,
                  }))
                }
              >
                <option value="">Select Column</option>
                {mapping.headers.map((header, index) => (
                  <option key={index} value={header}>
                    {header}
                  </option>
                ))}
              </select>
            </div>
            {/* select currency */}
            <div>
              <label>Select Currency Column:</label>
              <select
                onChange={(e) =>
                  setColumnMappings((prev) => ({
                    ...prev,
                    currency: e.target.value,
                  }))
                }
              >
                <option value="">Select Column</option>
                {["USD", "GBP", "CAD", "EUR", "MXN"].map((i) => {
                  return <option value={i}>{i}</option>;
                })}
              </select>
            </div>
            {/* select target domain */}
            <div>
              <label>Select Target Domain:</label>
              <select
                onChange={(e) =>
                  setColumnMappings((prev) => ({
                    ...prev,
                    target_domain: e.target.value,
                  }))
                }
              >
                <option value="">Select target Domain</option>
                {getMarketOptions(user).map((i) => {
                  return <option value={i.domain}>{i.domain}</option>;
                })}
              </select>
            </div>

            <button onClick={handleMappingConfirm}>Confirm Mapping</button>
            <div>
              <button
                onClick={() => {
                  // Save data to the database
                  console.log("Data to save:", previewData);
                  saveUpcList();
                  setModalUploadOpen(false);
                }}
              >
                Save Data
              </button>
            </div>
          </div>
        )}
        {/* save button */}

        {previewData.length > 0 && (
          <div>
            <h4>Preview Data</h4>
            <table border="1">
              <thead>
                <tr>
                  <th>{listType}</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {previewData.map((row, index) => (
                  <tr key={index}>
                    <td>{row?.[listType]}</td>
                    <td>
                      {row.price} - {columnMappings.currency}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {errorData.length > 0 && (
          <div>
            <h4>Errors</h4>
            <table border="1">
              <thead>
                <tr>
                  <th>Row</th>
                  <th>{listType}</th>
                  <th>Price</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                {errorData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.row}</td>
                    <td>{row.upc}</td>
                    <td>{row.price}</td>
                    <td>{row.error}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal>

      <div className="outer__inner new__page">
        <div className="onex_wl bg_white">
          <div className="onex_wl__wrapper">
            <div className="upload__head hhg">
              <div className="ttle_c">
                <h2 className="upload__title h2">Wholesale Module</h2>
                <div className="keys__info">
                  {translate(
                    "Manage, compare and view detailed analysis of your Asin lists."
                  )}
                </div>
              </div>
            </div>
            <div className="onex_wl__list">
              <div className="keys__enabled d_block">
                <div className="keys__list">
                  <div className="keys__item ss">
                    <div className="activity__top ss">
                      <div className="activity__item activity__item_calendar js-activity-item ffvv">
                        <button
                          onClick={() => setModalUploadOpen(true)}
                          className="button-stroke button-small activity__button js-activity-button"
                        >
                          <span>
                            <FeatherIcon icon={"upload-cloud"} />{" "}
                            {translate("Import")}
                          </span>
                        </button>
                      </div>
                    </div>

                    {/* <AsinsTable
                      isComparisonDrawer={isComparisonDrawer}
                      setComparisonDrawer={setComparisonDrawer}
                      data={bufferAsinLists?.map((i) => {
                        return {
                          ...i,
                          key: i.id,
                        };
                      })}
                      setSelectedAsinLists={setSelectedAsinLists}
                      selectedAsinLists={selectedAsinLists}
                      setSelectedAsinList={setSelectedAsinList}
                      selectedAsinList={selectedAsinList}
                      mergeAsinLists={mergeAsinLists}
                      deleteAsinLists={deleteAsinLists}
                      startComparisonProcess={startComparisonProcess}
                      stopComparisonProcess={stopComparisonProcess}
                      getAsinListAsins={getAsinListAsins}
                      refresh={getAsinLists}
                      setDownloadActive={setDownloadActive}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SavedAsins;
